import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
// @ts-nocheck — same transitional marker the rest of this extension uses.
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { PALETTES, applyPalette, loadStoredPalette, storePalette } from '../palettes';

/**
 * Gradient swatch button + popover that lets the visitor pick one of the
 * preset palettes. Rendered via extend(HeaderSecondary.prototype, 'items', …)
 * — being a real Mithril component means it survives the SPA reconciler
 * tearing the header subtree down on navigation / notification updates. The
 * previous imperative installPalettePicker() was attached once at
 * DOMContentLoaded and disappeared on the first route change (audit F3).
 *
 * All user-facing strings go through app.translator.trans() against the
 * ernestdefoe-aurora.forum.palette.* keys (audit F6/F7).
 */
export default class PaletteButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.open = false;
    this.current = loadStoredPalette();
    this.onDocumentClick = e => {
      if (!this.open) return;
      if (this.element && !this.element.contains(e.target)) {
        this.open = false;
        m.redraw();
      }
    };
    this.onKeydown = e => {
      if (e.key === 'Escape' && this.open) {
        this.open = false;
        m.redraw();
      }
    };
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('keydown', this.onKeydown);
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('keydown', this.onKeydown);
  }
  view() {
    const t = key => app.translator.trans("ernestdefoe-aurora.forum.palette.".concat(key));
    return m("button", {
      type: "button",
      className: "AuroraPaletteButton",
      "aria-label": t('button_label'),
      "aria-expanded": this.open ? 'true' : 'false',
      onclick: e => {
        e.stopPropagation();
        this.open = !this.open;
      }
    }, m("span", {
      className: "AuroraPaletteButton-label"
    }, t('palette')), this.open && this.popover(t));
  }
  popover(t) {
    return m("div", {
      className: "AuroraPalettePopover",
      role: "dialog"
    }, m("p", {
      className: "AuroraPalettePopover-title"
    }, t('title')), m("div", {
      className: "AuroraPalettePopover-grid"
    }, Object.entries(PALETTES).map(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        p = _ref2[1];
      return m("button", {
        key: name,
        type: "button",
        className: 'AuroraPaletteSwatch' + (name === this.current ? ' AuroraPaletteSwatch--active' : ''),
        "data-palette": name,
        "aria-label": app.translator.trans('ernestdefoe-aurora.forum.palette.apply', {
          palette: this.localizedLabel(t, name, p.label)
        }),
        onclick: e => {
          e.stopPropagation();
          applyPalette(name);
          storePalette(name);
          this.current = name;
        }
      }, m("span", {
        className: "AuroraPaletteSwatch-swatch",
        style: {
          background: "linear-gradient(120deg, ".concat(p.c1, " 0%, ").concat(p.c2, " 35%, ").concat(p.c3, " 70%, ").concat(p.c4, " 100%)")
        }
      }), m("span", {
        className: "AuroraPaletteSwatch-label"
      }, this.localizedLabel(t, name, p.label)));
    })));
  }

  /**
   * Localized palette name, falling back to the built-in English label on
   * PALETTES.<name>.label when the locale has no entry — keeps custom
   * palettes addable without forcing a translation.
   */
  localizedLabel(t, name, fallback) {
    const localized = t(name);
    const key = "ernestdefoe-aurora.forum.palette.".concat(name);
    const looksMissing = typeof localized === 'string' && localized === key;
    return looksMissing ? fallback : localized;
  }
}
flarum.reg.add('ernestdefoe-aurora', 'forum/components/PaletteButton', PaletteButton);